<template>
  <div class="input-select d-block" v-on-clickaway="closeSelect">
    <label @click="closeSelect">{{ $t(label) }} <span v-if="rules.required" class="warning-color">*</span></label>
    <div class="input-phone" :class="{required : localShouldShowError, disabled : disabled}">
      <div
        class="dial-box"
        @click="openListOnClick"
        tabindex="0"
        @focus="openListOnFocus">
        <CountryFlag
          class="m-r-10"
          v-if="dial_code !== ''"
          :country='flag'
          size='normal' />
        <div v-else class="field-flag-empty" />
        <span class="d-inline-block m-l-10" v-if="dial_code !== ''">
          {{ `+${dial_code}` }}
        </span>
        <Icon
          class="icon m-l-10"
          name="arrowDown"
          size="28" />
      </div>
      <input
        ref="numberInput"
        v-if="dial_code !== ''"
        class="input-inside"
        type="text"
        tabIndex="-1"
        :disabled="disabled"
        v-model="number"/>
    </div>
    <span v-if="localShouldShowError" class="warning-color validation-span" style="font-size: 12px;">{{ $t(errorMsg) }} {{ errorMsgAdditional }}</span>
    <div v-show="isListOpened" class="options-list">
      <input
        ref="searchField"
        class="search"
        v-model="search"
        @keydown="searchIt"
        :placeholder="$t('Search...')" />
      <ul>
        <li
          @keydown.prevent="nextItem"
          tabIndex="-1"
          v-for="(option, index) in filteredList"
          :key="`option-${index}`"
          :ref="`${randomSelectId}-${index}-opt`"
          :class="{active: indexItem === index}"
          @click="changeValue(index, option)">
          <CountryFlag :country='option.alpha2' size='small' />
          {{ `+${option.dial_code} - ${option.name}  (${option.alpha2})` }}
          <input :value="option.dial_code" type="checkbox" style="display: none;"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { parsePhoneNumber, AsYouTypeFormatter } from 'libphonenumber-js';
import { directive as onClickaway } from 'vue-clickaway';
import CountryFlag from 'vue-country-flag';
import countryList from '@/data/country.js';
import rules from "@/mixins/rules";

export default {
  name: 'PhoneSelect',
  mixins: [rules],
  components: {
    CountryFlag,
  },
  directives: {
    onClickaway: onClickaway,
  },
  props: {
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      default: 'phone',
    },
    preselectByCountry: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return {
          number: '', // broj
          country: '', // alpha2
        }
      },
    },
  },
  data() {
    return {
      indexItem: 0,
      isDialChoosedManualy: false,
      isListOpened: false,
      openedOnClick: false,
      search: '',
      dial_code: '',
      number: '',
      flag: '',
    };
  },
  created() {
    this.parseAndSetNumbers();
  },
  computed: {
    filteredList() {
      return countryList.filter(option => {
        const term = `+${option.dial_code} - ${option.name} ${option.alpha2}`;
        return term.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    randomSelectId() {
      return `select-${this.randomNumber()}`
    },
    localShouldShowError() {
      return this.externValidate(this.number)
    }
  },
  methods: {
    parseAndSetNumbers() {
      //Trim + from number if exist
      if (this.value.number) {
        this.value.number = this.value.number.replace(/\+/g, '');
      } else {
        this.value.number = ''
      }

      // Proveri da li je polje blokirano za manipulaciju kroz biranje zemlje
      if(!this.isDialChoosedManualy && this.value.country !== ''){
        let itemIndex = 0;
        const countryInfo = this.filteredList.filter((country, index) => {
          if(country.alpha2 === this.value.country){
            itemIndex = index;
            return country;
          };
        })[0];
        this.indexItem = itemIndex;
        this.flag = countryInfo.alpha2;
        this.dial_code = countryInfo.dial_code;
        // Promena radjena za contact view
        this.number = this.value.number.substring(countryInfo.dial_code.length);
        return;
      }
      // Proveri da li postoji broj
      if(this.value.number === '') {
        this.indexItem = 0;
        this.flag = '';
        this.dial_code = '';
        this.number = '';
      } else {
        let countryInfo = '';
        let itemIndex = 0;
        if(this.value.country === ''){
          let parsedNumber;
          try {
            parsedNumber = parsePhoneNumber(`+${this.value.number}1234`);
          } catch (e) {
            return; // unparseable number with no country — leave field as-is
          }
          countryInfo = this.filteredList.filter((country, index) => {
            if(country.dial_code === parsedNumber.countryCallingCode) {
              itemIndex = index;
              return country;
            }
          })[0];
        } else {
          countryInfo = this.filteredList.filter((country, index) => {
            if(country.alpha2 === this.value.country) {
              itemIndex = index;
              return country;
            }
          })[0];
        }
        this.flag = countryInfo.alpha2;
        this.indexItem = itemIndex;
        this.dial_code = countryInfo.dial_code;
        this.number = this.value.number.substring(countryInfo.dial_code.length);
      }
    },
    searchIt(event) {
      if(event.keyCode == 9) this.closeSelect();
      if (event.keyCode == 38 || event.keyCode == 40) {
      	this.nextItem(event);
      } else if (event.keyCode == 13) {
      	this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].click();
        this.$refs.searchField.focus();
      } else {
        this.search = event.target.value;
      }
    },
    changeValue(index, option) {
      this.isDialChoosedManualy = true;
      this.indexItem = index;
      this.isListOpened = false;
      this.openedOnClick = false;
      this.dial_code = option.dial_code || '';
      if (this.$refs.numberInput) {
        this.$refs.numberInput.focus();
      }
      this.$emit('input', {
        country: option.alpha2,
        number: `${this.dial_code}${this.number}`,
      });
      this.search = '';
    },
    nextItem (event) {
      if(event.keyCode == 9) this.closeSelect();
    	if (event.keyCode == 38 && this.indexItem > 0) {
      	this.indexItem--;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 40 && this.indexItem < this.filteredList.length - 1) {
      	this.indexItem++;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 13) {
      	this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].click();
        this.$refs.numberInput.focus();
      }
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    closeSelect() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.search = '';
    },
    openListOnClick() {
      if (this.disabled) {
        return;
      }
      if(this.openedOnClick) {
        this.closeSelect();
        return;
      }
      this.isListOpened = true;
      this.openedOnClick = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        this.$refs.searchField.focus();
      });
    },
    openListOnFocus() {
      if (this.disabled) {
        return;
      }
      this.isListOpened = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        this.$refs.searchField.focus();
      });
    },
  },
  watch: {
    number: function() {
      if (typeof this.number !== "number") {
        this.number = this.number.replace(/\D/g, '');
      }

      this.$emit('input', {
        country: this.flag,
        number: `${this.dial_code}${this.number}`,
      });
    },
    'value.country': function(newVal) {
      this.flag = newVal;
      this.parseAndSetNumbers();
    },
    'value.number': function() {
      this.parseAndSetNumbers();
    },
  },
}
</script>
<style>
.disabled {
  background: #f2f4f6!important;
}
</style>
